import React from 'react'
import Box from '@material-ui/core/Box'
import styled from 'styled-components'
import Typography from '@material-ui/core/Typography'
import { Switch, Grid } from '@material-ui/core'
import useFeatureFlags from 'src/hooks/useFeatureFlags'

const SubheadingText = styled.p`
    color: #000;
    font-size: 12px;
    font-weight: bold;
    padding: 20px 0px 10px 0px;
`

const ToggleText = styled(Typography).attrs({
  color: 'primary',
})`
  && {
    text-transform: uppercase;
    font-size: 11px;
  }
`

export const ChartToolsToggle = () => {

  const { getFlag, setFlag, error, loading } = useFeatureFlags()

  const flagName = 'use_chart_tools_grid'
  const useChartToolsGrid = getFlag(flagName)

  if (loading) { return null }

  return (
    <>
      <Box>
        <SubheadingText>
        Would you like to display the charting tools in grid format on Pilot App?
        </SubheadingText>
      </Box>
      <Grid component="label" container alignItems="center" spacing={1}>
        <Grid item>
          <Switch
            name="toggle"
            color="primary"
            checked={useChartToolsGrid === true}
            onChange={() => setFlag(flagName, !useChartToolsGrid)}
          />
        </Grid>
        <Grid item>
          <ToggleText>
            {typeof useChartToolsGrid === 'undefined' || useChartToolsGrid === false
              ? 'Disabled'
              : 'Enabled'}
          </ToggleText>
        </Grid>
      </Grid>
      {error && error.message}
    </>
  )
}

ChartToolsToggle.propTypes = {}

export default ChartToolsToggle
